/**
 * Enum for refund reasons.
 */
export enum RefundReason {
    /**
     * Refund requested by customer.
     */
    REQUESTED_BY_CUSTOMER = "requestedByCustomer",

    /**
     * Duplicate order.
     */
    DUPLICATE_ORDER = "duplicateOrder"
}